import { Section } from "../../../types";

const getHighestPosition = (prev: Section[]) => {
  let highest = 0;
  prev.forEach((section) => {
    if (section.position > highest) {
      highest = section.position;
    }
  });
  return highest;
};

const getHighestPicturePosition = (
  prev: Section[],
  sectionPosition: number
) => {
  let highest = 0;
  const currentSection = prev.find((x) => x.position === sectionPosition);
  currentSection?.pictures.forEach((picture) => {
    if (picture.position > highest) {
      highest = picture.position;
    }
  });
  return highest;
};

export { getHighestPicturePosition, getHighestPosition };
